import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when User toggles balance visibility.
 * @memberOf Playtech.API.events
 * @event user:toggleBalance
 * @type {callback}
 * @param {boolean[]} details details[0] is isShown
 * @example Playtech.on('user:toggleBalance', ([isShown]) => { ... });
 */
export const EVENT_USER_TOGGLE_BALANCE = 'user:toggleBalance';

export const useOnUserToggleBalance = (eventTarget) => {
    const handleEvent = useCallback((...isShown) => {
        const event = new CustomEvent(EVENT_USER_TOGGLE_BALANCE, { detail: isShown });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_USER_TOGGLE_BALANCE, handleEvent);

        return () => {
            publicEventsAPIService.off(EVENT_USER_TOGGLE_BALANCE, handleEvent);
        };
    }, [handleEvent]);
};
